import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface AppInfo {
  id: string;
  name: string;
  slug: string;
  description?: string;
  icon: string;
  color: string;
  isCore: boolean;
  sortOrder: number;
  bundleUrl?: string | null;
  path?: string;
}

interface PlatformState {
  // Available apps for the current organization
  availableApps: AppInfo[];
  setAvailableApps: (apps: AppInfo[]) => void;
  
  // Currently active app
  currentAppId: string | null;
  setCurrentApp: (appId: string) => void;
  
  // Get current app info
  getCurrentApp: () => AppInfo | undefined;
  
  // Check if an app is available
  hasApp: (appId: string) => boolean;
}

export const usePlatformStore = create<PlatformState>()(
  persist(
    (set, get) => ({
      availableApps: [],
      currentAppId: null,

      setAvailableApps: (apps) => {
        set({ availableApps: apps.sort((a, b) => a.sortOrder - b.sortOrder) });
        
        // If no current app set, default to first app
        const state = get();
        if (!state.currentAppId && apps.length > 0) {
          set({ currentAppId: apps[0].id });
        }
      },

      setCurrentApp: (appId) => {
        set({ currentAppId: appId });
      },

      getCurrentApp: () => {
        const state = get();
        return state.availableApps.find(app => app.id === state.currentAppId);
      },

      hasApp: (appId) => {
        return get().availableApps.some(app => app.id === appId);
      },
    }),
    {
      name: 'platform-storage',
      partialize: (state) => ({ currentAppId: state.currentAppId }),
    }
  )
);


